import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ReplaySubject, filter, raceWith, timer } from 'rxjs';

const timeBeforeTabIsInactive = 60_000 * 5;
const timeBeforeTabDead = 60_000 * 60 * 2;

@Injectable({
  providedIn: 'root',
})
export class TabFocusService {
  private platformId = inject<string>(PLATFORM_ID);
  public tabActive$ = new ReplaySubject<boolean>(1);
  public tabDead$ = new ReplaySubject<boolean>(1);
  public tabFocus$ = new ReplaySubject<boolean>(1);

  private deadTabReloader = this.tabDead$.pipe(filter(Boolean)).subscribe(() => {
    this.tabActive$.pipe(filter(Boolean)).subscribe(() => {
      if (window.onbeforeunload) return; // uploading
      location.reload();
    });
  });

  constructor() {
    if (isPlatformServer(this.platformId)) return;
    this.tabFocus$.next(true);
    this.tabActive$.next(true);

    window.addEventListener('blur', () => {
      this.tabFocus$.next(false);
      timer(timeBeforeTabIsInactive)
        .pipe(raceWith(this.tabFocus$.pipe(filter(Boolean))))
        .subscribe(() => {
          if (document.hasFocus()) return;
          this.tabActive$.next(false);

          timer(timeBeforeTabDead - timeBeforeTabIsInactive)
            .pipe(raceWith(this.tabFocus$.pipe(filter(Boolean))))
            .subscribe(() => {
              if (document.hasFocus()) return;
              this.tabDead$.next(true);
            });
        });
    });
    window.addEventListener('focus', () => {
      this.tabDead$.next(false);
      this.tabFocus$.next(true);
      this.tabActive$.next(true);
    });
  }
}
